import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';

import { FieldComponent } from './field.component';
import { SelectFieldComponent } from './select-field.component';

interface Standard {
  drop: boolean,
  fps: number
}

@Component({
  selector: 'app-timecode-standard-field',
  templateUrl: './timecode-standard-field.component.html',
  styleUrls: ['./timecode-standard-field.component.scss']
})
export class TimecodeStandardFieldComponent extends FieldComponent implements OnInit {

  @Output() standardChanged = new EventEmitter<{standard: Standard, value: any}>();
  @ViewChild('formatField') formatField: SelectFieldComponent;
  @ViewChild('dropField') dropField: SelectFieldComponent;

  dropValue: any;
  dropValues: any[] = [
    {displayed: 'DF', stored: 'DF', standard: {drop: true}, categories: ['DF']},
    {displayed: 'NDF', stored: 'NDF', standard: {drop: false}, categories: ['NDF']}
  ]
  formatValue: any;
  formatValues: any[] = [
    {displayed: "1080p 23.98", stored: "1080p 23.98", standard: {fps: 24, format: "1080p 23.98"}, linked_categories: ["NDF"]},
    {displayed: "1080i 29.97", stored: "1080i 29.97", standard: {fps: 30, format: "1080i 29.97"}, linked_categories: ["DF", "NDF"]},
    {displayed: "1080i 50", stored: "1080i 50", standard: {fps: 50, format: "1080i 50"}, linked_categories: ["NDF"]},
    {displayed: "1080i 59.94", stored: "1080i 59.94", standard: {fps: 60, format: "1080i 59.94"}, linked_categories: ["DF", "NDF"]},
    {displayed: "1080p 25", stored: "1080p 25", standard: {fps: 25, format: "1080p 25"}, linked_categories: ["NDF"]},
    {displayed: "720p 50", stored: "720p 50", standard: {fps: 50, format: "720p 50"}, linked_categories: ["NDF"]},
    {displayed: "720p 59.94", stored: "720p 59.94", standard: {fps: 60, format: "720p 59.94"}, linked_categories: ["DF", "NDF"]},
    {displayed: "IMX 30 (SD 29.97)", stored: "IMX 30 (SD 29.97)", standard: {fps: 30, format: "IMX 30 (SD 29.97)"}, linked_categories: ["DF", "NDF"]},
    {displayed: "NTSC", stored: "NTSC", standard: {fps: 30, format: "NTSC"}, linked_categories: ["DF", "NDF"]},
    {displayed: "PAL", stored: "PAL", standard: {fps: 25, format: "PAL"}, linked_categories: ["NDF"]}
  ]
  id: string = 'timecode_standard';
  loaded: boolean = false;
  required: boolean = false;
  get blank(): boolean { return this.formatField.blank && this.dropField.blank }
  get dirty(): boolean { return this.formatField.dirty || this.dropField.dirty }
  get standard(): Standard { 
    if (this.formatValue != null && this.dropValue != null) {
      return {
        drop: this.dropValue.standard.drop,
        fps: this.formatValue.standard.fps
      }
    } else {
      return null
    }
  }
  get touched(): boolean { return this.formatField.touched || this.dropField.touched }
  get valid(): boolean { return this.formatField.valid && this.dropField.valid }
  get value() { return {
    drop: this.dropValue,
    format: this.formatValue,
  }}

  constructor(cd: ChangeDetectorRef) { super(cd) }

  ngOnInit() {
    if (this.field.locked) { this.locked = true }
    if (this.field.required) { this.required = true }

    if (this.defaultValue == null) {
      this.loadDefaultValue();
    }
    this.loadInitialState(this.draftData);
  }

  ngAfterViewInit() {
    this.loaded = true;
    this.updateDropCategories();
    this.standardChanged.emit({
      standard: this.standard,
      value: this.value
    });
    this.viewLoaded.emit(this);
  }

  loadDefaultValue() {
    if (this.templateData != null) {
      this.defaultValue = this.templateData
    } else {
      this.defaultValue = this.field.defaultValue;
    }
  }

  loadInitialState(draftValue?: any) {
    let value = draftValue != null ? draftValue : this.defaultValue;
    if (value != null) {
      this.dropValue = value.drop;
      this.formatValue = value.format;
    }
  }

  setValue(value, emit: boolean = true) {
    if (value != null) {
      this.formatValue = value.format;
      this.formatField.setValue(this.formatValue, false)
      this.dropValue = value.drop;
      this.dropField.setValue(this.dropValue, false)
    } else {
      this.formatValue = null;
      this.formatField.setValue(null, false);
      this.dropValue = null;
      this.dropField.setValue(null, false);
    }
    if (this.loaded) { this.updateDropCategories() }
    if (emit) {
      this.emitValue();
    }
  }

  updateDropCategories(userInitiated = false) {
    let categories = this.formatValue != null ? this.formatValue.linked_categories : null;
    this.dropField.setCategories(categories, false)
    this.dropValue = this.dropField.value;
    if (this.formatValue != null && userInitiated && this.dropValue == null) {
      let firstValue = this.dropField.categoryValues[0];
      this.dropField.setValue(firstValue, false)
      this.dropValue = firstValue;
    }
  }

  onValueChange(event) {
    switch (event.field) {
    case 'drop':
      this.dropValue = event.value != null ? this.dropValues.find((v) => v.stored == event.value.stored) : null;
      break;
    case 'format':
      this.formatValue = event.value != null ? this.formatValues.find((v) => v.stored == event.value.stored) : null;
      if (this.loaded) { this.updateDropCategories(true) }
      break;
    }
    this.emitValue();
    this.standardChanged.emit({
      standard: this.standard,
      value: this.value
    });
  }

  emitValue() {
    this.valueChanged.emit({field: this.id, value: this.value});
  }

  valuesEqual(a, b): boolean {
    if (a == null || b == null) {
      return a == b;
    } else {
      return (a.drop == b.drop) && (a.format == b.format);
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/timecode-standard-field.component.ts